import React, { useState, useEffect } from 'react';
import stylesInputs from "../../../assets/styles/inputs.module.css";
import styles from "./EventModal.module.css";
import { ClockIcon } from '../../Icons/ClockIcon';

interface TimeInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
}

export const TimeInput: React.FC<TimeInputProps> = ({
    value,
    onChange,
    placeholder = "__:__",
    className
}) => {
    const [displayValue, setDisplayValue] = useState(value || '');
    const [isFocused, setIsFocused] = useState(false);

    const formatTimeString = (input: string): string => {
        // Удаляем все нецифровые символы
        const numbers = input.replace(/\D/g, '');
        
        if (numbers.length === 0) return '';
        
        // Проверяем и корректируем часы
        let hours = numbers.substring(0, 2);
        if (hours.length === 1) {
            if (parseInt(hours) > 2) {
                hours = `0${hours}`;
            }
        } else if (parseInt(hours) > 23) {
            hours = '23';
        }

        // Проверяем и корректируем минуты
        let minutes = numbers.substring(2, 4);
        if (minutes.length === 1) {
            if (parseInt(minutes) > 5) {
                minutes = `0${minutes}`;
            }
        } else if (parseInt(minutes) > 59) {
            minutes = '59';
        }

        // Форматируем вывод
        if (numbers.length > 0) {
            if (hours.length === 2 && minutes.length > 0) {
                return `${hours}:${minutes}`;
            }
            return hours;
        }
        return '';
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const input = e.target.value.replace(/\D/g, '');
        if (input.length <= 4) {
            const formatted = formatTimeString(input);
            setDisplayValue(formatted);
            onChange(formatted);
        }
    };

    const handleBlur = () => {
        setIsFocused(false);
        if (displayValue.length === 1 || displayValue.length === 2) {
            const formatted = formatTimeString(displayValue.padEnd(4, '0'));
            setDisplayValue(formatted);
            onChange(formatted);
        }
    };

    const getInputState = () => {
        if (!displayValue) return styles.inputEmpty;
        if (isFocused) return styles.inputFocused;
        return styles.inputFilled;
    };

    return (
        <div className={styles.inputWrapper}>
            <ClockIcon className={`${styles.inputIcon} ${getInputState()}`} />
            <input
                type="text"
                value={displayValue}
                onChange={handleChange}
                onFocus={() => setIsFocused(true)}
                onBlur={handleBlur}
                placeholder={placeholder}
                className={`${styles.inputField} ${styles.timeField} ${stylesInputs.mainInput} ${className || ''}`}
                maxLength={5}
            />
        </div>
    );
};
